import React from "react";
import { formatPrice } from "../helpers";
import PropTypes from "prop-types";

class Order extends React.Component {
  
  static propTypes = 
  {
    fishes: PropTypes.object,
    order: PropTypes.object,
    removeFromOrder: PropTypes.func
  };


  renderOrder = key => { //returning everythung to diaplay
    const fish = this.props.fishes[key];
    const count = this.props.order[key];
    const isAvailable = fish && fish.status === "available"; //checking is fish is present
    if(!fish) return null; //if fish is deleted 
    if (!isAvailable) 
    { //if fish is unavailable
      return (
        <li key={key}>
          Sorry {fish ? fish.name : "fish"} is no longer available
        </li> //if fish is not avilable that is we have deleted that fish, then use 'fish is not available' else show 'fish.name is not available'
      );
    }
    return (
      <li key={key}>
        {count} lbs {fish.name}
        {formatPrice(count * fish.price)}
        <button onClick={() => this.props.removeFromOrder(key)}>&times;</button>
      </li>
    );
  };
  render() { 
    const orderIds = Object.keys(this.props.order);// calculating everything before returning
    const total = orderIds.reduce((prevTotal, key) => {
      const fish = this.props.fishes[key];
      const count = this.props.order[key];
      const isAvailable = fish && fish.status === "available";
      if (isAvailable) {
        return prevTotal + count * fish.price;
      }
      return prevTotal;
    }, 0);
    return (
      <div className="order-wrap">
        <h2>Order</h2>
        <ul className="order">{orderIds.map(this.renderOrder)}</ul>
        <div className="total">
          Total:
          <strong>{formatPrice(total)}</strong>
        </div>
      </div>
    );
  }
}

export default Order;
